import {lightenDarkenColor} from "../lightenDarkenColor";

export function getSlotStyling(store, itemSlotMapping) {
    const mode = store.state.planning.mode;
    const statusColorsSettings = store.state.planning.statusColors;

    const taskId = itemSlotMapping.taskId;
    const persons = itemSlotMapping.persons;
    const equipments = itemSlotMapping.equipments;
    const teams = itemSlotMapping.teams;

    const task = store.state.planning.tasks[taskId];
    let status = task.status;

    if( statusColorsSettings === 'resources' ){
        if( mode === 'person' ){
            const personId = Object.keys(persons)[0];
            const person = store.state.planning.persons[personId];
            if (person) {
                status = person.status;
            }
        }else if (mode === 'equipment') {
            const equipmentId = Object.keys(equipments)[0];
            const equipment = store.state.planning.equipments[equipmentId];
            if (equipment) {
                status = equipment.status;
            }
        }else if (mode === 'project') {
            // In project mode, prioritize person status if available, then equipment status
            const personId = Object.keys(persons)[0];
            if (personId) {
                const person = store.state.planning.persons[personId];
                if (person && person.status) {
                    status = person.status;
                }
            } else {
                const equipmentId = Object.keys(equipments)[0];
                if (equipmentId) {
                    const equipment = store.state.planning.equipments[equipmentId];
                    if (equipment && equipment.status) {
                        status = equipment.status;
                    }
                }
            }
        }
    }


     let backgroundImage;
    if (task.finished_at) {
        backgroundImage =
            'repeating-linear-gradient(-45deg,transparent,transparent 3px,rgba(0,0,0,.15) 0,rgba(0,0,0,.15) 6px)';
    }
    if (
        Object.keys(persons).length === 0 &&
        Object.keys(equipments).length === 0 &&
        Object.keys(teams).length === 0
    ) {
        backgroundImage =
            'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTE0NTJGRkQxRDg2MTFFOUJGMTZEQkFDNEU4ODg5OEUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTE0NTJGRkUxRDg2MTFFOUJGMTZEQkFDNEU4ODg5OEUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBMTQ1MkZGQjFEODYxMUU5QkYxNkRCQUM0RTg4ODk4RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBMTQ1MkZGQzFEODYxMUU5QkYxNkRCQUM0RTg4ODk4RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvGeHLoAAAAfSURBVHjaYmBgYFD7//8/AwwzgghkwMSABjAEAAIMAKTeDCBxJBnlAAAAAElFTkSuQmCC")';
    }

    return {
        backgroundColor: status.color,
        darkenBackgroundColor: lightenDarkenColor(status.color, -15),
        color: status.text_color,
        backgroundImage: backgroundImage,
    }

}